import { render } from "./ProjectDetailsStats.vue?vue&type=template&id=b886415e&scoped=true"
import script from "./ProjectDetailsStats.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsStats.vue?vue&type=script&lang=js"

import "./ProjectDetailsStats.vue?vue&type=style&index=0&id=b886415e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b886415e"]])

export default __exports__